import { useCallback, useEffect, useState } from 'react'

import { isScheduleNow } from 'helpers/scheduleHelpers'
import { redirectEndpoints } from 'settings/_apiSettings'

import { isScheduleTokenEnabled } from 'utils'

interface Schedule {
   tokenHasBeenFilled: boolean | null
   virtualRoomHash: string
   planGroupCode: string
   startDate: string
   endDate: string
 }

interface UseScheduleTokenProps {
  schedule: Schedule
}

interface IUseScheduleToken {
  openTokenModal: boolean
  onCloseModal: () => void
  onJoinVirtualRoom: () => void
  onClickJoinVirtualRoom: () => void
}

export function useScheduleToken({ schedule }: UseScheduleTokenProps): IUseScheduleToken {
  const [isTimeUp, setIsTimeUp] = useState(false)
  const [openTokenModal, setOpenTokenModal] = useState(false)
  const [patientCloseAutomaticModal, setPatientCloseAutomaticModal] = useState(false)

  const hasSchedule = Object.keys(schedule).length > 0

  const onCloseModal = () => {
    setOpenTokenModal(false)
    setPatientCloseAutomaticModal(true)
  }

  const onClickJoinVirtualRoom = useCallback(() => {
    window.location.assign(`${redirectEndpoints}/${schedule.virtualRoomHash}`)
  }, [schedule])

  const onJoinVirtualRoom = useCallback((isAutomaticOpenModal = false) => {
    if (!hasSchedule) return

    const { tokenHasBeenFilled } = schedule

    switch (tokenHasBeenFilled) {
    case true: // ja preencheu o token
      if (isAutomaticOpenModal) return
      onClickJoinVirtualRoom()
      break

    case false: // precisa preencher
      setOpenTokenModal(true)
      break

    default: // demais casos que não utilizam token
      if (isAutomaticOpenModal) return
      onClickJoinVirtualRoom()
      break
    }
  }, [schedule, onClickJoinVirtualRoom])

  useEffect(() => {
    setIsTimeUp(isScheduleNow(schedule.startDate, schedule.endDate))
  }, [schedule])

  useEffect(() => {
    if (patientCloseAutomaticModal) return

    if (!hasSchedule) return

    const { tokenHasBeenFilled, planGroupCode } = schedule

    const planGroupUseScheduleToken = isScheduleTokenEnabled(planGroupCode)

    if (planGroupUseScheduleToken && isTimeUp && !tokenHasBeenFilled) {
      onJoinVirtualRoom(true)
    }
  }, [onJoinVirtualRoom, isTimeUp, schedule, patientCloseAutomaticModal, hasSchedule])

  return {
    openTokenModal,
    onCloseModal,
    onJoinVirtualRoom,
    onClickJoinVirtualRoom,
  }
}